import { Link } from "@tanstack/react-router";
import { FileText } from "lucide-react";

import type { TaskRead } from "@/lib/task-context";

/** The task's background: the sources Bear has read while working on it. */
export function TaskContext({
  projectId,
  taskId,
  taskOpen,
  legacyChat,
  reads,
  loaded,
}: {
  projectId: string;
  taskId: string;
  taskOpen: boolean;
  legacyChat: boolean;
  reads: TaskRead[];
  loaded: boolean;
}) {
  return (
    <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5">
      <div className="text-[10px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
        Sources read {reads.length ? `· ${reads.length}` : ""}
      </div>
      {reads.length ? (
        <div className="mt-2 divide-y border-y">
          {reads.map((read) => (
            <Link
              key={read.path}
              to={
                taskOpen || legacyChat
                  ? "/p/$projectId/$branch/explorer/files/$"
                  : "/p/$projectId/$branch/workbench/$view"
              }
              params={{
                projectId,
                branch: legacyChat ? "main" : taskId,
                _splat: read.path,
                view: "document",
              }}
              search={
                taskOpen || legacyChat
                  ? { view: undefined }
                  : { file: read.path }
              }
              className="flex min-w-0 gap-2 py-3 text-xs hover:text-primary"
            >
              <FileText className="mt-0.5 size-3.5 shrink-0 text-muted-foreground" />
              <span className="min-w-0">
                <span className="block truncate font-medium" title={read.path}>
                  {read.path}
                </span>
                <span
                  className="mt-1 block truncate text-[11px] text-muted-foreground"
                  title={read.windows.join(", ")}
                >
                  {read.windows.join(", ")}
                  {read.revision ? ` · r${read.revision}` : ""}
                </span>
              </span>
            </Link>
          ))}
        </div>
      ) : (
        <p className="mt-3 text-xs text-muted-foreground">
          {loaded ? "No sources read yet." : "Loading sources…"}
        </p>
      )}
    </div>
  );
}
